export const LITERATURE_CITATION_NODE_NAME = 'literature-citation';
